import MenuSearchComponent from 'components/desktop/Menu/Search/MenuSearchComponent';

const MenuArchiveContainer = () => {
	const renderContent = () => {
		return (
			<>
				<main className="container">
					<MenuSearchComponent archive={true} />
				</main>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default MenuArchiveContainer;
